import { Button } from '../../../components/common/Buttons';
import { useTrans } from '../../../services/i18n';
import SetPhone from './SetPhone';
import { ModalDialog } from '../../../components/common/Dialogs';
import useBooleanHandlers from '../../../hooks/useBooleanHandlers';
import { SpacingContainer } from '../../../components/common/Containers/Base';
import Typography from '../../../components/common/Typography';

const PhoneNumber = ({ auth, modalTitleFontSize = '1.5rem' }) => {
  const { trans } = useTrans();
  const [open, onOpenModal, onCloseModal] = useBooleanHandlers();

  const hasPhone = Boolean(auth?.phone);
  const title = hasPhone ? 'Change Phone Number' : 'Add Phone Number';

  return (
    <>
      <Button onClick={onOpenModal} id="personal-info-edit" variant="outlined" color="primary" size="small">
        {hasPhone ? trans('edit') : trans('add')}
      </Button>

      <ModalDialog
        open={open}
        onClose={onCloseModal}
        title={
          <Typography weight="600" fontFamily="lexend" style={{ fontSize: modalTitleFontSize }}>
            {title}
          </Typography>
        }
      >
        <SpacingContainer py={0}>
          <SetPhone auth={auth} onClose={onCloseModal} />
        </SpacingContainer>
      </ModalDialog>
    </>
  );
};

export default PhoneNumber;